import React from "react";
import InputFiles from "react-input-files";

export default function UploadButton({ onChange, children }) {
  return <InputFiles onChange={onChange}>{children}</InputFiles>;
}
